import { HttpContextToken } from '@angular/common/http';

/** Prevents the token/recovery interceptors from handling auth refresh calls. */
export const SKIP_AUTH_SESSION = new HttpContextToken<boolean>(() => false);

/** Ensures one failed request is retried at most once after a refresh. */
export const AUTH_SESSION_RETRY_ATTEMPTED = new HttpContextToken<boolean>(
  () => false
);
